import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-send-via-social-media',
  templateUrl: './send-via-social-media.component.html',
  styleUrls: ['./send-via-social-media.component.scss'],
})
export class SendViaSocialMediaComponent  implements OnInit {

  @Input() onPathSelected!: (data: any) => void;

  hideWhatsappOption: boolean = false;

  constructor(
    private _popoverController: PopoverController
  ) { }

  ngOnInit() {}

  // Navigate to path
  routeToPath(path: any) {
    this.onPathSelected({ path: path });
    this._popoverController.dismiss();
  }

}
